import { Menu, MenuItem } from '@mui/material'

export default function QuoteMenu({
  open,
  onClose,
  anchorEl,
  onNewLine,
  onNewVersion,
  onClone,
  onDelete,
  onNTECalculation,
  onITESTools,
  onRFQ,
}: {
  open: boolean
  onClose: () => void
  anchorEl: HTMLElement | null
  onNewLine: () => void
  onNewVersion: () => void
  onClone: () => void
  onDelete: () => void
  onNTECalculation: () => void
  onITESTools: () => void
  onRFQ: () => void
}) {
  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MenuItem
        onClick={() => {
          onNewLine()
        }}
      >
        New Line
      </MenuItem>
      <MenuItem
        onClick={() => {
          onNewVersion()
        }}
      >
        New Version
      </MenuItem>
      <MenuItem
        onClick={() => {
          onClone()
        }}
      >
        Clone
      </MenuItem>
      <MenuItem
        onClick={() => {
          onDelete()
        }}
      >
        Delete Quote
      </MenuItem>
      <MenuItem
        onClick={() => {
          onNTECalculation()
        }}
      >
        NTE Calculation
      </MenuItem>
      <MenuItem
        onClick={() => {
          onITESTools()
        }}
      >
        ITES Tools
      </MenuItem>
      <MenuItem
        onClick={() => {
          onRFQ()
        }}
      >
        RFQ
      </MenuItem>
    </Menu>
  )
}
